import { color } from 'features/common/constants';
import { fade } from 'features/common/utils';
import styled from 'styled-components/macro';

export const Option = styled.option`
  color: ${fade(color.slateDarker, 30)};
  display: none;
`;
